import styled from '@emotion/styled';
import { Box, Tab, Tabs } from '@mui/material';
import { FC } from 'react';
import { TabPanelProps } from 'src/models/Management.interface';

export const StyledHorizontalTabs = styled(Tabs)`
  min-height: 44px;
  border-bottom: 1px solid #e0e0e0;

  & .MuiTabs-indicator {
    height: 3px;
    border-radius: 3px 3px 0 0;
    background: linear-gradient(90deg, #0f52ba 0%, #1976d2 100%);
  }

  & .MuiTabs-flexContainer {
    gap: 8px;
  }
`;

export const StyledHorizontalTab = styled(Tab)<{ selected?: boolean }>`
  font-family: 'Outfit', sans-serif;
  font-size: 14px;
  font-weight: ${({ selected }) => (selected ? '600' : '400')};
  color: ${({ selected }) => (selected ? '#0f52ba' : '#75838a')};
  text-transform: none;
  min-height: 44px;
  padding: 12px 24px;
  border-radius: 8px 8px 0 0;
  transition: all 0.2s ease-in-out;

  &:hover {
    color: #0f52ba;
    background-color: rgba(15, 82, 186, 0.04);
  }

  &.Mui-selected {
    color: #0f52ba;
    background-color: rgba(15, 82, 186, 0.08);
  }
`;

export const TabPanelContainer = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const TabPanel: FC<TabPanelProps> = ({
  children,
  value,
  index,
  idPrefix = 'tabpanel',
}) => {
  return (
    <TabPanelContainer
      role="tabpanel"
      hidden={value !== index}
      id={`${idPrefix}-${index}`}
      aria-labelledby={`${idPrefix}-tab-${index}`}
    >
      {value === index && children}
    </TabPanelContainer>
  );
};
